import { render } from "./addeditassetcategoryattribute.vue?vue&type=template&id=32dcb36b"
import script from "./addeditassetcategoryattribute.vue?vue&type=script&lang=js"
export * from "./addeditassetcategoryattribute.vue?vue&type=script&lang=js"

import "./addeditassetcategoryattribute.vue?vue&type=style&index=0&id=32dcb36b&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__